// Step 5d Phase 4 — client device-registry API (enrol + revocation status).
// Revoke itself is admin-only with no client UI in Phase 4 (deferred to the menus era).

import { apiFetch } from './api';

/** Register this device with the server registry (online, at enrolment) so it can be revoked. */
export async function serverEnrollDevice(deviceId: string): Promise<{ revoked: boolean } | null> {
  const res = await apiFetch<{ device_id: string; revoked: boolean }>('/api/devices/enroll', {
    method: 'POST',
    body: JSON.stringify({ device_id: deviceId }),
  });
  return res.error || !res.data ? null : { revoked: res.data.revoked };
}

/** Poll the device's revocation status (piggybacked on the board's focus-poll). */
export async function fetchDeviceStatus(deviceId: string): Promise<{ revoked: boolean; purge: boolean } | null> {
  const res = await apiFetch<{ revoked: boolean; purge: boolean }>(`/api/devices/status?device_id=${encodeURIComponent(deviceId)}`);
  return res.error || !res.data ? null : res.data;
}
